import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";
import { motion } from "framer-motion";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Log error for tracking
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );

    // Set document title for 404 page
    document.title = "404 - Page Not Found";
  }, [location.pathname]);

  return (
    <PageTransition>
      <div className="bg-black text-white noise-bg min-h-screen flex flex-col">
        <header>
          <Navbar />
        </header>

        <main className="flex-grow flex items-center justify-center">
          <div className="container mx-auto px-6 py-16 text-center">
            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="max-w-2xl mx-auto"
            >
              <h1 className="text-7xl md:text-9xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-600">
                404
              </h1>
              <p className="text-xl md:text-2xl text-neutral-300 mb-8">
                The page you're looking for doesn't exist or has been moved.
              </p>
              <Link
                to="/"
                className="inline-block px-8 py-3 rounded-lg bg-white text-black font-medium hover:bg-neutral-200 transition-colors"
              >
                Return to Home
              </Link>
            </motion.section>
          </div>
        </main>

        <footer>
          <Footer />
        </footer>
      </div>
    </PageTransition>
  );
};

export default NotFound;
